import React, { useEffect, useState } from 'react';
import payment_success from '../../assets/payment_success.webp';
import payment_failure from '../../assets/payment-failure.jpeg';
import { Link } from 'react-router-dom';
function ValidationPayment(props) {
	const [status, setStatus] = useState('');
	useEffect(() => {
		setStatus(props.props.location?.state?.status);
	});
	return (
		<div className="container">
			{status === 'succeeded' ? (
				<div className="col-12 justify-content-center k-semibold-20">
					<div className="row justify-content-center">
						Paiement effectué avec succès
					</div>
					<div className="row justify-content-center">
						<img src={payment_success} alt="" width={150} height={150} />
					</div>
					<div>
						<Link to={'/'} className="btn btn-yellow btn-block k-regular-15">
							Suivant
						</Link>
					</div>
				</div>
			) : (
				<div id="mainContainer">
					<div className="box">
						<div className="row justify-content-center k-semibold-20">
							Erreur lors du paiement... Veuillez réessayer
						</div>{' '}
						<div className="row justify-content-center k-semibold-20">
							{/* <img src={payment_failure} alt="" width={150} height={150} /> */}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

export default ValidationPayment;
